import { Component, OnInit, ChangeDetectorRef, ViewChild, TemplateRef } from '@angular/core';
import { TimeService } from '../time.service';
import { HttpService } from '../http.service';
import { MatDialog } from '@angular/material';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import { ShipmentDetailsComponent } from '../dashboardModals/shipment-details/shipment-details.component';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import * as moment from 'moment';

import { DateTime } from 'luxon';
import { Messages } from '../constants/messages';
import { SubscribeComponent } from '../subscribe/subscribe.component';
import { ShareComponent } from '../share/share.component';
import { environment } from 'src/environments/environment';
import { ReAssignComponent } from '../re-assign/re-assign.component';
import { TranslateService } from '@ngx-translate/core';
import { SendEmailComponent } from '../share/send-email/send-email.component';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { EventService } from '../event.service';
declare var google: any;

@Component({
  selector: 'app-shipments-map',
  templateUrl: './shipments-map.component.html',
  styleUrls: ['./shipments-map.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})
export class ShipmentsMapComponent implements OnInit {
  map;
  mapMarkers = [];
  polyline;
  selectedOrderAllLocationsData = [];
  selectedOrder: any;

  showLoader = false;
  markers: any;
  bounds = new google.maps.LatLngBounds();

  messages = new Messages();

  shipmentsArray = [];
  totalShipments = 0;
  country;
  shipmentCounts = {
    pending: 0,
    intransit: 0,
    completed: 0,
    cancelled: 0
  };

  filterSIN: any = '';
  shipmentFilters: any = {
    limit: 10,
    skip: 0,
    from: DateTime.fromMillis(Date.now()).startOf('day').ts,
    to: DateTime.fromMillis(Date.now()).endOf('day').ts
  };
  selectedShipment: any = {};
  showMapButtons = false;
  isSearch = false;
  isScroll = false;
  searchCleared = false;
  unitChanged = false;

  simMode = false;
  appMode = false;
  gpsMode = false;
  coordinates = [];
  flightPath: any;
  path;
  pathTypes: any = {
    sim: [],
    app: [],
    gps: false
  };
  src = {
    lat: 0,
    lng: 0
  };
  estimatedValues = {
    estDistanceKms: '',
    estDistanceMts: 0,
    estTime: ''
  };
  showTracking = false;

  picon = {
    url: 'assets/Pickup.svg',
    scaledSize: new google.maps.Size(30, 30)
  };
  dicon = {
  url: 'assets/Drop.svg',
  scaledSize: new google.maps.Size(30, 30)
  };
  acceptRef;
  warningRef;

  searchTextChanged = new Subject<object>();
  subscription: Subscription;
  date_filter: any = {
    from: DateTime.fromMillis(Date.now()).startOf('day').ts,
    to: DateTime.fromMillis(Date.now()).endOf('day').ts
  };

  trackerUrl = environment.TRACKER_URL;
  @ViewChild('warning', {static: true}) warning: TemplateRef<any>;
  @ViewChild('acceptDialog', {static: true}) acceptDialog: TemplateRef<any>;
  carrierId: Subscription;

  constructor(private http: HttpService, private snackbar: SnackbarService, private dialog: MatDialog,
              private timeService: TimeService, private valid: ValidationService, private changeDetection: ChangeDetectorRef,
              private translation: TranslateService, private events: EventService, ) {
    this.showTracking = environment.country == 'IN';

  }

  ngOnInit() {
    this.initMap();
    this.getShipments(this.shipmentFilters);
    this.getShipmentsCount();
    this.country = environment.country;
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.shipmentFilters = {
          limit: 10,
          skip: 0,
          from: DateTime.fromMillis(Date.now()).startOf('day').ts,
          to: DateTime.fromMillis(Date.now()).endOf('day').ts
        };
        this.unitChanged = true;
        this.getShipments(this.shipmentFilters);
        this.getShipmentsCount();
      },
      (err: any) => {
        console.log('err ::', err);
      }
    );
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

  readableTime(timestamp) {
    return moment(timestamp).format('DD-MM-YYYY');
  }

  reSubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(search => search)
    ).subscribe((x) => {
      this.getShipments(x);
      this.getShipmentsCount();
     });
    this.changeDetection.detectChanges();
  }

  getShipmentsCount() {
    // this.date_filter.from = ( d => new Date(d.setDate(d.getDate())) )(new Date); // sets the from date to 30 days before date
    // this.date_filter.from.setHours(0, 0, 0, 0); // set hours to 12:00AM
    // this.date_filter.to = new Date(); // set the to_date to today's date
    // this.date_filter.to.setHours(23, 59, 59, 0);
    // this.date_filter.from = this.timeService.toUTCEpoch(this.date_filter.from);
    // this.date_filter.to = this.timeService.toUTCEpoch(this.date_filter.to);
    this.date_filter.from = this.shipmentFilters.from;
    this.date_filter.to = this.shipmentFilters.to;
    this.http.get('shipment/counts', this.date_filter).subscribe(
      (response: any) => {
        this.shipmentCounts.pending = (response.data.PNDG || 0) + (response.data.ASN || 0);
        this.shipmentCounts.intransit = response.data.ITNS || 0;
        this.shipmentCounts.completed = response.data.CPTD || 0;
        this.shipmentCounts.cancelled = response.data.CNCL || 0;
       }
    );
  }
  initMap(lat = 12.960691, lng = 77.580116) {
    const mapProp = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    };
    this.map = new google.maps.Map(document.getElementById('shipmentMap'), mapProp);
  }

  selectShipment(shipment) {
    this.selectedShipment = shipment;
    this.showMapButtons = true;
    this.plotPickupsDrops(shipment);
    this.getShipmentPath(shipment);
  }

  plotPickupsDrops(shipment) {
    if (this.mapMarkers.length) {
      this.clearAllMarkers();
    }
    const from = shipment.from;
    const to = shipment.to;

    from.forEach((e, i) => {
      this.placeMarker(e.location.geo_point.coordinates, 'P' + (i + 1), this.picon);
    });
    to.forEach((e, i) => {
      this.placeMarker(e.location.geo_point.coordinates, 'D' + (i + 1), this.dicon);
    });

  }
  changeDateFormat(date) {
    return this.timeService.toShortDateMonth(date) + ' | ' + this.timeService.formatDate(date);
  }
  timeConvert(n) {
    const num = n;
    const hours = (num / 60);
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    return rhours + ' hr ' + rminutes + ' min '  ;
  }

  completeShipment(shipment) {
    const dialogData = {
      name: 'Complete Shipment',
      shipment_id: shipment._id,
      sin: shipment.sin,
      text: this.messages.SHIPMENT_DETAILS.complete,
      url: 'shipment/complete'
    };

    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200 || result == 'yes') {
          this.getShipments(this.shipmentFilters, 1);
          this.getShipmentsCount();
      }
    });
  }
  getShipments(filter: any = {}, resetLoader = 0) {
    if (resetLoader) {
      filter.skip = 0;
      this.shipmentFilters.skip = 0;
    }
    this.showLoader = true;
    (this.isSearch || this.unitChanged || !this.isScroll || this.searchCleared) ? this.shipmentsArray = [] : '';
    this.http.post('v2/shipment/many', filter).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.clearAllMarkers();
          (this.isSearch || resetLoader) ?  this.shipmentsArray = [] : '';
          this.totalShipments = data.data.count;
          const result = data.data.shipments;
          result.forEach((element) => {
            const temp: any = {
              material: []
            };
            temp._id = element._id;
            temp.sin = element.SIN;
            temp.from = element.pickups;
            temp.from.forEach((e) => {
              e.date_time = element.pickup_date;
            });
            temp.to = element.deliveries;
            temp.to.forEach((e) => {
              e.date_time = element.delivery_date;
            });
            temp.reqVehicleType = (element.vehicle_type && element.vehicle_type.name) ? element.vehicle_type.name : 'N/A';
            temp.reqVehicleType_id = (element.vehicle_type && element.vehicle_type._id) ? element.vehicle_type._id : 'N/A';
            temp.vehicleType = (element.driver) ? element.driver.vehicle_type.name
                : (element.assigned_driver) ? element.assigned_driver.vehicle_type.name : '--';
            temp.vehicleNumber = (element.driver) ? element.driver.vehicle_no
                : (element.assigned_driver) ? element.assigned_driver.vehicle_no : '--';
            temp.orderId = (element.order) ? element.order._id : ' ';
            temp.unique_code = element.unique_code;
            temp.material = element.materials;
            if (element.latest_status === 'PNDG') {
              temp.status = 'Pending';
              temp.icon_url = 'assets/Pending.svg' 
            } else if (element.latest_status === 'ALC') {
              temp.status = 'Allocated';
            } else if (element.latest_status === 'ACPT') {
              temp.status = 'Accepted';
              temp.icon_url = 'assets/Accepted.svg';
            } else if (element.latest_status === 'ASN') {
              temp.status = 'Assigned';
              temp.icon_url = 'assets/Assigned.svg' 
            } else if (element.latest_status === 'ITNS') {
              temp.status = 'In Transit';
              temp.icon_url = 'assets/InTransit.svg' 

            } else if (element.latest_status === 'CPTD') {
              temp.status = 'Completed';
              temp.icon_url = 'assets/Completed.svg' 

            } else if (element.latest_status === 'SP') {
              temp.status = 'Towards Pickup';
              temp.icon_url = 'assets/towards-pickup.svg'
            } else if (element.latest_status === 'AP') {
              temp.status = 'At Pickup';
              temp.icon_url = 'assets/at-pickup.svg'
            } else if (element.latest_status === 'ALD') {
              temp.status = 'At Delivery';
              temp.icon_url = 'assets/at-delivery.svg'
            } else {
              temp.status = 'Cancelled';
              temp.icon_url = 'assets/Cancelled.svg'
            }
            temp.inTransit = ( temp.status == 'In Transit' || temp.status == 'Towards Pickup' || temp.status == 'At Pickup' || temp.status == 'At Delivery' ) ? true : false;

            temp.selectedOrderAllLocationsData = temp.from.concat(temp.to);
            temp.scheduledDate = this.timeService.toShortDate(element.pickups[0].updated_at);
            temp.actualDate = this.timeService.toShortDate(element.pickups[0].created_at);
            temp.driverName = (element.driver) ? element.driver.name
                        : (element.assigned_driver) ? element.assigned_driver.name : '--';
            temp.driverMobile = (element.driver) ? element.driver.mobile
                        : (element.assigned_driver) ? element.assigned_driver.mobile : '--';
            temp.driver_id = (element.driver) ? element.driver._id
            : (element.assigned_driver) ? element.assigned_driver._id : '--';
            temp.notAccepted = (!element.driver) ? true : false;
            temp.hasSmartPhone = (element.assigned_driver) ? element.assigned_driver.hasSmartPhone : false;
            temp.estimatedTime = (element.order) ? this.timeConvert(element.order.estimated.duration) : '--';
            temp.totalDistance = (element.order) ? ((element.order.estimated.distance / 1000).toFixed(2) + ' kms') : '--';
            temp.remainingDistance = element.remaining ? (temp.status == 'In Transit' ? (element.remaining.distance / 1000).toFixed(2) + ' kms' : '--') : '--';
            temp.remainingTime = element.remaining ? (temp.status == 'In Transit' ? (this.timeService.toDayMinSec(element.remaining.duration)) : '--') : '--';
            temp.currentLocation = '--';
            temp.pickupDate = this.timeService.toShortDateTime(element.pickup_date);
            temp.deliveryDate = this.timeService.toShortDateTime(element.delivery_date);
            temp.disableGenerateInvoice = (element.carrier_invoices.length !== 0);
            temp.isCarrierShipment = (!element.order);
            temp.scheduledDeliveryDate = this.timeService.toShortDate(element.deliveries[0].updated_at);
            temp.actualDeliveryDate = this.timeService.toShortDate(element.deliveries[0].created_at);
            temp.simTracking = element.simTracking;
            temp.tracking = (element.trip_tracker.methods.length) ? true : false;
            this.shipmentsArray.push(temp);
            this.selectShipment(this.shipmentsArray[0]);
          });
          this.unitChanged = false;
          this.searchCleared = false;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        this.unitChanged = false;
        if (err.error.statusCode === 401) {
          this.valid.logout();
        }
      }
    );
  }
  openViewModal(shipment,  tabI = 0) {
    this.showLoader = true;
    this.http.get('shipment/one?shipmentId=' + shipment._id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const shipmentDetails = data.data;
          shipmentDetails.tabIndex = tabI;
          if (shipmentDetails.tabIndex === 6) {
            shipmentDetails.generateFreight = true;
          }
          this.showLoader = false;
          const dialogRef = this.dialog.open(ShipmentDetailsComponent, {
            data: shipmentDetails,
            width: '1250px',
            maxWidth:'95vw !important'
          });

          dialogRef.afterClosed().subscribe(result => {});
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode === 401) {
          this.valid.logout();
        }
      }
    );
  }

  clearAllMarkers() {
    this.mapMarkers.forEach(element => element.setMap(null));
    this.mapMarkers.length = 0;
  }
  placeMarker(markers, label= '', icon: any = '') {

    const latLng = {
      lat: markers[1] || 0.0,
      lng: markers[0] || 0.0
    };
    const marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      label: {
        text: label || '',
        color: '#ffffff'
      },
      icon
    });

    this.mapMarkers.push(marker);
    this.bounds.extend(latLng);
    this.map.fitBounds(this.bounds);
    marker.setMap(this.map);
  }

  searchFilter(value, type) {
    this.changeDetection.detectChanges();
    switch (type) {
      case 'SIN':
        (value.length >= 3) ? this.shipmentFilters.SIN = value : (value.length == 0) ? this.clearFilter() : ''; // if search input is empty get all the shipments else with the filter
        this.isSearch = true;
        break;
      case 'shipper':
        (value.length >= 3) ? this.shipmentFilters.shipper_name = value : (value.length == 0) ? this.clearFilter() : ''; // if search input is empty get all the shipments else with the filter
        this.isSearch = true;
        break;
      case 'date':
        const date1: any = DateTime.fromJSDate(value.value); // here 'value' is event
        if (!date1.invalid) {
          this.shipmentFilters.from = date1.startOf('day').ts;
          this.shipmentFilters.to = date1.endOf('day').ts;
          this.date_filter.from = date1.startOf('day').ts;
          this.date_filter.to = date1.startOf('day').ts;
          this.isSearch = true;
        }
        break;
      default:
        this.clearFilter();
        break;
    }

    this.shipmentFilters.limit = 10;
    this.shipmentFilters.skip = 0;
    this.reSubscribe();
    this.searchTextChanged.next(this.shipmentFilters);
  }

  clearFilter() {
    // this.shipmentFilters.to = DateTime.fromMillis(Date.now()).endOf('day').ts;
    // this.shipmentFilters.from = DateTime.fromMillis(Date.now()).startOf('day').ts;
    // this.date_filter.from = DateTime.fromMillis(Date.now()).startOf('day').ts;
    // this.date_filter.to = DateTime.fromMillis(Date.now()).endOf('day').ts;
    this.clearAllMarkers();
    this.isSearch = false;
    // this.date_filter = {};
    this.getShipmentsCount();
    this.shipmentFilters.limit = 10;
    this.shipmentFilters.skip = 0;
    delete this.shipmentFilters.SIN;
    this.filterSIN = '';
    this.getShipments(this.shipmentFilters);
  }

  getShipmentPath(shipment) {
    this.appMode = false;
    this.simMode = false;
    this.gpsMode = false;
    this.http.get('/v1/shipment/path?shipment=' + shipment._id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          if (data.data.sim.length) {
            const simData = data.data.sim;
            this.pathTypes.sim = simData;
            this.simMode = true;
          }
          if (data.data.app.length) {
            const appData = data.data.app;
            this.pathTypes.app = appData;
            this.appMode = true;

          }
          if (data.data.gps && data.data.gps ==  true) {
            this.pathTypes.gps = true;
            this.gpsMode = true;

          }
          this.drawPath();
          this.estimatedValues = {
            estDistanceKms: '',
            estDistanceMts: 0,
            estTime: ''
          };
        }
      });
  }

  drawPath() {
    let locations = [];
    if (this.flightPath) {
      this.flightPath.setMap(null); // Clear polyline
      this.coordinates = [];
    }
    // const bounds = new google.maps.LatLngBounds();
    if (this.appMode) {
      locations = [];
      this.pathTypes.app.forEach(element => {
        const latLng = {
          lat: 0.0,
          lng: 0.0
        };
        latLng.lat = element.location[1];
        latLng.lng =  element.location[0];
        const temp: any = {};
        temp.location = latLng;
        locations.push(temp);
        this.coordinates.push(latLng);
        this.bounds.extend(latLng);
      });
    } else if (this.simMode) {
      locations = [];
      this.pathTypes.sim.forEach(element => {
        const latLng = {
          lat: 0.0,
          lng: 0.0
        };
        latLng.lat = element.location[1];
        latLng.lng =  element.location[0];
        const temp: any = {};
        temp.location = latLng;
        locations.push(temp);
        this.coordinates.push(latLng);
        this.bounds.extend(latLng);
      });
    } else if (this.gpsMode) {
      this.http.get('v1/shipment/gps_path', {shipment_id: this.selectedShipment._id}).subscribe((data: any) => {
        this.path = data.data.polylines;
        this.src.lat = data.data.lastLocation[0];
        this.src.lng = data.data.lastLocation[1];
        this.plotPolyLine(this.path);
      });
    }

    if (!this.gpsMode) {
      this.flightPath = new google.maps.Polyline({
        path: this.coordinates,
        geodesic: true,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 2
      });
      this.flightPath.setMap(this.map);
      this.map.fitBounds(this.bounds);

      // Calculate estimated distance and time
      const src = this.coordinates[this.coordinates.length - 1];
      const destination = this.selectedShipment.from[this.selectedShipment.from.length - 1].location.geo_point.coordinates;
      this.getDistance(src, destination);

    } else {
      const destination = this.selectedShipment.from[this.selectedShipment.from.length - 1].location.geo_point.coordinates;
      this.getDistance(this.src, destination);
    }
  }

  getDistance(p, d) {
    const contxt = this;
    const service = new google.maps.DistanceMatrixService();
    if (p && d.length) {
      service.getDistanceMatrix(
        {
          origins: [new google.maps.LatLng(p.lat, p.lng)],
          destinations: [new google.maps.LatLng(d[1], d[0])],
          travelMode: 'DRIVING',
          avoidHighways: false,
          avoidTolls: false,
        }, (distance, status) => {
          contxt.estimatedValues.estDistanceKms = (distance.rows[0].elements[0].distance) ? distance.rows[0].elements[0].distance.text : 'N/A';
          contxt.estimatedValues.estDistanceMts = (distance.rows[0].elements[0].distance) ? distance.rows[0].elements[0].distance.value : 'N/A';
          contxt.estimatedValues.estTime = (distance.rows[0].elements[0].duration) ? distance.rows[0].elements[0].duration.text : 'N/A';
        }
      );
    }
  }

  plotPolyLine(data, strokeColor = '#FF0000') {
    let jsonData;
    data.forEach(element => {
      jsonData = {
        overview_polyline: {
          points: element
        }
      };
    });

    const path = google.maps.geometry.encoding.decodePath(jsonData.overview_polyline.points);

    for (const p of path) {
      this.bounds.extend(p);
    }

    this.flightPath = new google.maps.Polyline({
      path,
      strokeColor,
      strokeWeight: 3,
      fillColor: '#FF0000',
    });

    this.flightPath.setMap(this.map);
    this.map.fitBounds(this.bounds);
  }

  acceptDia(shipment) {
    this.acceptRef = this.dialog.open(this.acceptDialog);
    this.acceptRef.afterClosed().subscribe(
      (data: any) => {
        if (data) {
          this.accept(shipment);
        }
      }
    );
  }

  accept(shipment) {
    if ((shipment.notAccepted) || shipment.hasSmartPhone) {
      if (shipment.driverName !== '--') {

        const acceptData: any = {
          shipment_id: shipment._id,
          driver_id: shipment.driver_id
        };
        this.http.post('shipment/accept', acceptData).subscribe(
          (data: any) => {
            if (data.statusCode === 200) {
              this.snackbar.openSnackBar(this.translation.instant('SHIPMENT_MAP_VIEW.success'), '');
              this.getShipments({}, 1);
            }
          },
          (err: any ) => {
            this.snackbar.openSnackBar(err.error.message, '', 'err');
          }
        );
      }

    }
  }

  onScroll() {
    this.isScroll = true;
    this.isSearch = false;
    this.shipmentFilters.limit = 10;
    this.shipmentFilters.skip = this.shipmentFilters.skip + 10;
    this.getShipments(this.shipmentFilters);
  }

  warningDialog(shipment) {
    if (shipment.driverName !== '--') {
      this.warningRef = this.dialog.open(this.warning);
      this.warningRef.afterClosed().subscribe(
        (data: any) => {
          if (data) {
            this.openAssignModal(shipment, 'Re assign Driver');
          }
        }
      );
    } else {
      this.openAssignModal(shipment, 'Assign Driver');
    }
  }

  openAssignModal(data, label= 'Assign Driver') {
    const from = data.from[0].location.name + ' - ' + data.from[0].location.city;
    const to = data.to[data.to.length - 1].location.name + ' - ' + data.to[data.to.length - 1].location.city;
    data = {
      shipment_id: data._id,
      order_id: data.orderId,
      vehicle_type: {
        _id: data.reqVehicleType_id != 'N/A' ? data.reqVehicleType_id : '',
        name: data.reqVehicleType
      },
      header: label,
      from,
      to,
      sin: data.sin
    };
    const dialogRef = this.dialog.open(ReAssignComponent, {
      data:data,
      width: "1250px",
      maxWidth: "95vw !important",
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getShipments({}, 1);
      }
    });
  }

  openSubscribe(element) {
    const dialogData: any = {
      data: element
    };
    this.http.get('shipment/simTrack/status?id=' + element._id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          dialogData.response = data.data;
          this.dialog.open(SubscribeComponent, {
            data: dialogData
          });
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '');
      }
    );
  }

  share(element) {
    this.dialog.open(ShareComponent, {
      data: this.trackerUrl + element.unique_code
    });
  }

  generateFreight(data) {
    data.generateFreight = true;
    this.openViewModal(data, 6);
  }

  sendEmail(element) {
    const dataToSend: any = {
      id: element._id,
      trackingUrl: this.trackerUrl + element.unique_code
    };
    this.dialog.open(SendEmailComponent, {
      data: dataToSend
    });
  }

}
